import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryProvider } from '@/providers/QueryProvider'
import { TenantProvider } from '@/providers/TenantProvider'
import { FeatureFlagsProvider } from '@/providers/FeatureFlagsProvider'
import { AuthProvider } from '@/providers/AuthProvider'
import { TableColumnPrefsProvider } from '@/providers/TableColumnPrefsProvider'
import { I18nProvider } from '@/i18n/I18nProvider'
import { initI18n } from '@/i18n/i18n'
import App from './App'
import './index.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

// Start terminology before the first render, not in I18nProvider's effect. On a
// warm load (cached locale list and namespaces) init then completes right here,
// synchronously, so the provider's first render already has it and the app paints
// without the "Loading terminology…" screen (z8nrz7fxhz). A failure is handled
// where the provider calls initI18n() again: the call is idempotent and retries
// after a rejection.
initI18n().catch(() => {})

createRoot(rootElement).render(
  <StrictMode>
    <QueryProvider>
      <AuthProvider>
        <TenantProvider>
          <FeatureFlagsProvider>
            <I18nProvider>
              {/* Inside AuthProvider: table layouts are keyed by user id, so the
                  store has to be able to read the signed-in principal. Outside
                  the router, so a layout survives navigation. */}
              <TableColumnPrefsProvider>
                <App />
              </TableColumnPrefsProvider>
            </I18nProvider>
          </FeatureFlagsProvider>
        </TenantProvider>
      </AuthProvider>
    </QueryProvider>
  </StrictMode>
)
